<template>
  <div class="compare" v-if="!radarRefreshing.data">
    <div class="compare__box">
      <header class="compare__box__header">
        <ui-button
          class="compare__box__header__close"
          @click.prevent="toggleCompare(false)"
          button="secondary"
          :label="$t('commons.buttons.close')"
          :icon-only="true"
          icon="close"
        />
        <div class="compare__box__header__title">
          {{ $t('compares.title') }}
        </div>
      </header>
      <div class="compare__box__container">
        <div class="compare__box__container__section">
          <ui-checkbox
            @input="changeCheck"
            class="compare__box__container__section__checkbox"
            v-for="(compareZone, index) in compareZones[currentKpi]"
            v-model="model"
            :id="`compare-${compareZone.key}`"
            :key="'zone ' + index"
            :value="compareZone.key"
            color="#00a74b"
          >
            {{ compareZone.name[$i18n.locale] || compareZone.name.default }}
          </ui-checkbox>
        </div>
      </div>
      <footer class="compare__box__footer">
        <ui-button
          @click.native="clearCompareZone()"
          class="gmap-zone__box__container__cta__button"
          button="secondary"
          variant="gtr"
          :label="$t('gmap.actions.clearZones')"
        />
        <ui-button
          @click.native="navigate"
          class="gmap-zone__box__container__cta__button"
          button="cta"
          variant="gtr"
          :label="$t('gmap.actions.compare')"
        />
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { isMobile } from '@/utils/navigator.util'
import UiButton from '@/components/UI/Button.vue'
import UiCheckbox from '@/components/UI/Checkbox.vue'
import {
  buildFilters,
  buildSource,
  buildBrands,
  buildDate,
  buildDistribution,
  buildLocation,
  buildLevel,
  buildCountries,
} from '@/utils/urlParams.util'

export default {
  name: 'GmapCompare',
  components: {
    UiButton,
    UiCheckbox,
  },
  props: {},
  data() {
    return {
      isMobile: isMobile(),
      selectZones: {
        review: [],
      },
    }
  },
  computed: {
    ...mapState({
      settings: state => state.data.settings,
      brandZones: state => state.data.zones,
      brands: state => state.data.brands,
      zones: state => state.data.zones,
      compareZones: state => state.data.compareZones,

      currentSource: state => state.refine.currentSource,
      currentDistribution: state => state.refine.currentDistribution,
      currentDistance: state => state.refine.currentDistance,
      currentCountries: state => state.refine.currentCountries,
      activeBrands: state => state.refine.activeBrands,
      activeFilters: state => state.refine.activeFilters,
      activeGroups: state => state.refine.activeGroups,
      currentKpi: state => state.refine.currentKpi,
      currentTimeline: state => state.refine.currentTimeline,

      radarFilters: state => state.radar.filters,
      radarRefreshing: state => state.radar.refreshing,
    }),
    model: {
      get() {
        if (
          (this.zones?.[this.currentKpi].length === this.compareZones?.[this.currentKpi].length &&
            !this.selectZones?.review.length) ||
          !this.selectZones?.review.length
        ) {
          return []
        }

        if (this.compareZones?.[this.currentKpi].length > 0) {
          return this.selectZones?.review.map(zone => zone.key)
        }
        const keySelectZones = this.selectZones.review.map(zone => zone.key)
        return keySelectZones
      },
      set() {},
    },
    getZonesKey() {
      let keys = ''
      this.selectZones.review.filter(zone => (keys += zone.key + ','))
      keys = keys.slice(0, keys.length - 1)
      return keys
    },
  },
  methods: {
    ...mapActions({
      setCurrentLocation: 'data/setCurrentLocation',
      setZones: 'data/setZones',
      getCompareZones: 'data/getCompareZones',

      toggleCompare: 'radar/toggleCompare',
      toggleRefreshData: 'radar/toggleRefreshData',
    }),
    async clearCompareZone() {
      const markerRoutes = ['markers', 'division']
      await this.setCurrentLocation(null)
      this.toggleCompare(false)
      if (this.$route.name === 'zones') {
        await this.setZones(this.compareZones)
      }
      this.$router.push({
        name: markerRoutes.includes(this.$route.name) ? 'markers' : 'zones',
        params: { id: this.$route.params.id },
        query: this.$route.query,
      })
    },
    refreshLocations(closeCurrentLocation = true) {
      const route = this.$route
      this.toggleRefreshData(true)
      if (closeCurrentLocation) {
        this.setCurrentLocation(null)
      }
      const internalId = route.params.location
      const level = route.query.level || route.params.level
      const setting = this.settings.filter(setting => setting.key === this.currentKpi)[0]
      let urlParams = ''
      urlParams += buildLevel(level)
      urlParams += buildSource(this.currentSource)
      urlParams += buildDistribution(this.currentDistribution, this.radarFilters.distribution)
      urlParams += buildBrands(this.activeBrands, this.brands[this.currentKpi].brands, this.activeGroups)
      urlParams += buildFilters(this.activeFilters)
      urlParams += buildLocation(internalId, this.currentDistance)
      urlParams += buildCountries(this.currentCountries)
      urlParams += buildDate(this.currentTimeline)

      return Promise.all([this.getCompareZones({ setting, urlParams, compareZones: true })]).then(() => {
        this.toggleRefreshData(false)
      })
    },
    changeCheck(value) {
      const review = { review: [] }
      value.forEach(key => {
        this.compareZones[this.currentKpi].forEach(zone => {
          if (key === zone.key) {
            review.review.push(zone)
          }
        })
      })
      this.selectZones = review
    },
    async navigate() {
      const markerRoutes = ['markers', 'division']
      this.toggleCompare(false)
      await this.setZones(this.selectZones)
      if (this.zones[this.currentKpi].length < 1) {
        await this.setCurrentLocation(null)
        this.$router.push({
          name: markerRoutes.includes(this.$route.name) ? 'markers' : 'zones',
          params: { id: this.$route.params.id },
          query: this.$route.query,
        })
      } else {
        this.$router.push({
          name: markerRoutes.includes(this.$route.name) ? 'division' : 'divisionZones',
          params: {
            ...this.$route.params,
            level: this.zones[this.currentKpi][0].level ? this.zones[this.currentKpi][0].level : 2,
            key: this.getZonesKey,
          },
          query: this.$route.query,
        })
      }
    },
  },
  async created() {
    if (
      !this.compareZones?.[this.currentKpi] ||
      this.compareZones[this.currentKpi].length < this.zones?.[this.currentKpi].length ||
      this.compareZones?.[this.currentKpi][0]?.level !==
        parseInt(this.$route.query.level || this.$route.params.level || 2)
    ) {
      await this.refreshLocations()
    }

    if (this.zones?.[this.currentKpi].length != this.compareZones?.[this.currentKpi].length) {
      this.selectZones = this.zones
    }
  },
}
</script>

<style lang="scss" scoped>
.compare {
  @include wrapper(flex-end);

  @media (min-width: $screen-sm) {
    @include wrapper(
      $justify: flex-start,
      $padding: $gutter-md $gutter-md calc(#{$gutter-md} * 2 + #{$button-min-height-desktop}) 0
    );

    bottom: initial;
    left: $gutter-md;
    width: calc(#{$gmap-sidebar-width-tablet} + #{$gutter-md});
  }

  @media (min-width: $screen-lg) {
    width: calc(#{$gmap-sidebar-width-desktop} + #{$gutter-md});
  }

  &__box {
    @include box;

    width: $gmap-sidebar-width-mobile;

    @media (min-width: $screen-sm) {
      width: $gmap-sidebar-width-tablet;
    }

    @media (min-width: $screen-lg) {
      width: $gmap-sidebar-width-desktop;
    }

    &__header {
      @include header;

      &__close {
        @include close;
      }

      &__clear {
        margin: 0 4px;
      }

      &__title {
        @include title;
      }
    }

    &__container {
      padding: $gutter-sm;
      overflow: auto;

      @media (min-width: $screen-sm) {
        padding: $gutter-md;
      }

      &__section {
        &__checkbox {
          margin-bottom: 12px;
          width: 100%;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    &__footer {
      @include footer;
    }
  }
}
</style>
